// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2yuOO","subContainer":"_2gzCw","title":"_1rpTf","body":"_3V10k","cta":"ySZra","image":"_3D1_D"};